(function () {
  if (window.dvQuantityControlsBound) return;
  window.dvQuantityControlsBound = true;

  function normalizeQuantity(value) {
    var quantity = parseInt(value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function updateQuantity(purchase, quantity) {
    var input = purchase.querySelector('[data-dv-quantity-input]');
    var decrease = purchase.querySelector('[data-dv-quantity-decrease]');
    if (!input || !decrease) return;

    input.value = normalizeQuantity(quantity);
    decrease.disabled = Number(input.value) <= 1;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dv-quantity-decrease], [data-dv-quantity-increase]');
    if (!button) return;

    var purchase = button.closest('[data-dv-standard-purchase]');
    var input = purchase && purchase.querySelector('[data-dv-quantity-input]');
    if (!purchase || !input) return;

    event.preventDefault();
    var change = button.hasAttribute('data-dv-quantity-increase') ? 1 : -1;
    updateQuantity(purchase, normalizeQuantity(input.value) + change);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-dv-quantity-input]')) return;

    var purchase = event.target.closest('[data-dv-standard-purchase]');
    if (purchase) updateQuantity(purchase, event.target.value);
  });
})();
